import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { ClinicalLicensure, Provider } from 'src/app/models/patient.model';
import { User } from 'src/app/models/user.model';
import { InitialDataModel } from 'src/app/services/models/initial-data-model.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-add-providers',
  templateUrl: './add-providers.component.html',
  styleUrls: ['./add-providers.component.scss'],
})
export class AddProvidersComponent implements OnInit {
  providerForm: UntypedFormGroup;
  providers: User[] = [];
  providerColumns = ['rank', 'name', 'available', 'role', 'actions'];
  dataSource: MatTableDataSource<Provider> = new MatTableDataSource();
  providerRoles$: Observable<string[]>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddProvidersComponent>,
    private fb: UntypedFormBuilder,
    private initData: InitialDataModel,
    private utilsService: UtilsService
  ) {}

  ngOnInit(): void {
    this.providerRoles$ = this.utilsService.getProviderRoles();
    this.initProviders();
    this.initForm();
    this.initTable();
    this.setProviderListener();
  }

  initForm(): void {
    this.providerForm = this.fb.group({
      providerSelected: [''],
      providers: [''],
    });
  }

  initTable(): void {
    this.dataSource.data = (this.data.providers ?? []).map((provider) => ({
      ...provider,
    }));
  }

  async initProviders(): Promise<void> {
    await this.initData.getProviders();
    this.providers = (Object.values(this.initData.allClientUsers) as User[])
      .filter((client) => client.roles.isClient)
      .sort((clientA, clientB) => this.utilsService.sortUsersByAlphabeticLastNameOrder(clientA, clientB));
  }

  setProviderListener(): void {
    this.providerForm.get('providerSelected').valueChanges.subscribe((value) => {
      this.addProvider(value);
    });
  }

  addProvider(provider: User): void {
    if (this.dataSource.data.find((p) => p.uid === provider.user_id)) {
      return;
    }
    this.dataSource.data.push({
      uid: provider.user_id,
      name: `${provider.firstName} ${provider.lastName}`,
      email: provider.email,
      isAvailable: true,
      rank: this.dataSource.data.length + 1,
      role: ClinicalLicensure.REGISTERED_NURSE,
    });
    this.dataSource.data = [...this.dataSource.data];
  }

  removeProvider(provider: User): void {
    this.dataSource.data = this.dataSource.data.filter((p) => p !== provider);
    this.saveIndexesChanges();
  }

  drop(event: CdkDragDrop<string[]>): void {
    const previousIndex = this.dataSource.data.findIndex((row) => row === event.item.data);
    moveItemInArray(this.dataSource.data, previousIndex, event.currentIndex);
    this.dataSource.data = [...this.dataSource.data]; // Refresh the dataSource for the table to update
    this.saveIndexesChanges();
  }

  saveIndexesChanges(): void {
    this.dataSource.data.forEach((provider, index) => {
      provider.rank = index + 1;
    });
  }

  saveProviders(): void {
    this.dialogRef.close(this.dataSource.data ?? []);
  }

  close(): void {
    this.dialogRef.close();
  }
}
